import { render, staticRenderFns } from "./SlideFeature.vue?vue&type=template&id=513fbda4&scoped=true&"
import script from "./SlideFeature.vue?vue&type=script&lang=js&"
export * from "./SlideFeature.vue?vue&type=script&lang=js&"
import style0 from "./SlideFeature.vue?vue&type=style&index=0&id=513fbda4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513fbda4",
  null
  
)

export default component.exports